import { render, staticRenderFns } from "./ServiceMenu.vue?vue&type=template&id=92de0570"
import script from "./ServiceMenu.vue?vue&type=script&lang=js"
export * from "./ServiceMenu.vue?vue&type=script&lang=js"
import style0 from "./ServiceMenu.vue?vue&type=style&index=0&id=92de0570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports